import { z } from "zod";
import { dateSchema } from "./date";

export const paymentsSchema = z.object({
  amount: z.number(),
  dueDate: dateSchema,
  guid: z.string(),
  latest: z.boolean(),
  paid: z.boolean(),
  paymentIdHash: z.string(),
  paymentType: z.string(),
  url: z.string(),
  variableSymbol: z.string(),
});

export type Payment = z.infer<typeof paymentsSchema>;
